import {get, set} from "./CachingUtils"
import {toast} from "react-toastify";

const qcDirectoryName = "qc-report-saving-dir";

/**
 * @param {string} dirname
 * @param {boolean} requestPerms
 * @return {Promise<FileSystemDirectoryHandle|false>}
 */
async function getDownloadDir(dirname, requestPerms = true) {
    /**
     * @type FileSystemDirectoryHandle
     */
    let cachedFileHandle = await get(dirname);

    if (!cachedFileHandle) {
        if (!requestPerms) {
            return false;
        }

        if (!window.showDirectoryPicker) {
            if (requestPerms)
                toast.warn("Your browser is missing a crucial feature required to enable secure downloading.");

            return false;
        }

        try {
            cachedFileHandle = await window.showDirectoryPicker({mode: "readwrite"});
            if (cachedFileHandle) {
                await set(dirname, cachedFileHandle);
            } else {
                return false;
            }
        } catch (e) {
            console.error(e);

            toast.error("Failed to get download location");

            return false;
        }
    }

    try {
        let rw = {mode: "readwrite"};
        if ((await cachedFileHandle.queryPermission(rw)) === "granted") {
            return cachedFileHandle;
        } else if ((await cachedFileHandle.requestPermission(rw)) === "granted") {
            return cachedFileHandle;
        } else {
            toast.error("You need to grant permissions to download files");
            return false;
        }
    } catch (e) {
        console.error(e);
        return false;
    }
}

async function getDownloadFileHandle(cachedFileHandle, fileName, directoryTree = [], create = false) {
    if (!cachedFileHandle)
        return false;

    let directoryHandle = cachedFileHandle;

    for (let i = 0; i < directoryTree.length; i++) {
        console.log(directoryHandle);
        try {
            directoryHandle = await directoryHandle.getDirectoryHandle(directoryTree[i], { create: create });
        } catch (e) {
            console.error(e);

            return false;
        }
    }

    try {
        console.log(directoryHandle, fileName);

        return (await directoryHandle.getFileHandle(fileName, {create: create})) || false;
    } catch (e) {
        console.error(e);

        return false;
    }
}

async function getFileName(details) {
    const startDate = toShortDate(details.winO);
    const endDate = toShortDate(details.winC);

    return `QC-${(getClientAbb(locsDict[details.lID].clientID))}-${locsDict[details.lID].buildingID}_${(startDate === endDate ? startDate : startDate + '-' + endDate)}_${details.eID}.pdf`;
}

async function checkExists(outfile, testSum) {
    let foile;
    if (!outfile)
        return false;
    try {
        foile = await outfile.getFile();
    } catch (e) {
        console.error(e);

        return false;
    }
    const buff = await foile.arrayBuffer()
    const hashBuffer = await crypto.subtle.digest('SHA-256', buff);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const checksum = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');

    console.log(hashArray, checksum, testSum);

    return checksum === testSum;
}

/**
 * @param url
 * @return {Promise<Blob>}
 */
async function getBlob(url) {
    try {
        const response = await fetch(`/wp-content/uploads/${url}`);
        if (!response.ok) {
            throw `HTTP error! status: ${response.status}`;
        } else {
            console.log("DLING", response);
            let blob = await response.blob();
            console.log(blob);
            console.log(blob.size);
            return blob;
        }
    } catch (error) {
        throw error;
    }
}

function qcFileName(wo) {
    function toShortDate(strin = new Date()) {
        return `${strin.getMonth().toString().padStart(2, '0')}-${strin.getDate().toString().padStart(2, '0')}-${strin.getFullYear().toString().padStart(2, '0').slice(2)}`;
    }

    const startDate = toShortDate(wo.windowOpenDate);
    const endDate = toShortDate(wo.windowCloseDate);

    const fname = `QC-${wo.location.client.abbreviation}-${wo.location.buildingID}_${(startDate === endDate ? startDate : startDate + '-' + endDate)}_${wo.externalID}.pdf`;
    return fname;
}

function qcFileDirs(wo) {
    return [wo.location.client.abbreviation, `${wo.location.client.abbreviation}-${wo.location.buildingID}`];
}

/**
 * @param {SC_WorkorderObject} wo
 * @param cachedFileHandle
 * @return {Promise<boolean>}
 */
async function downloadQCReport(wo, alerts = false, cachedFileHandle = getDownloadDir(qcDirectoryName), forceRedownload = false) {
    cachedFileHandle = await cachedFileHandle;

    if (!cachedFileHandle) {
        if (alerts)
        toast.warn("Failed to get download location");
        return false;
    }
    const outfile = await getDownloadFileHandle(cachedFileHandle, qcFileName(wo), qcFileDirs(wo), true);

    if (!outfile) {
        if (alerts)
        toast.warn("Failed to get download file");
        return false;
    }

    if (!forceRedownload && await checkExists(outfile, wo.report.sum)) {
        if (alerts)
            toast.info("QC already downloaded!");
        // pass
        return true;
    } else {
        let blob = await getBlob(wo.report.href);

        let writer = await outfile.createWritable();
        await writer.write(blob);
        await writer.close();

        if (alerts)
        toast.info("QC downloaded successfully!");

        return true;
    }
}

async function checkQCExists(wo) {
    if (!wo.report || !wo.location || !wo.location.client) {
        // console.log("Incomplete wo", wo.location.client, !wo.report, !wo.location, !wo.location.client);

        return false;
    }

    let cachedFileHandle = await getDownloadDir(qcDirectoryName, false);

    if (!cachedFileHandle) {
        // console.log("No fh");

        return false;
    }

    const outfile = await getDownloadFileHandle(cachedFileHandle, qcFileName(wo), qcFileDirs(wo), false);

    if (!outfile) {
        // console.log("No of");

        return false;
    }

    return await checkExists(outfile, wo.report.sum);
}

/**
 * @param {File} file
 * @return {Promise<string>}
 */
function readfile(file) {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsText(file, "UTF-8");
        reader.onload = function (evt) {
            resolve(evt.target.result.trim());
        }
        reader.onerror = function (evt) {
            reject(evt);
        }
    });
}

function resizeImgToBLOB(v) {
    return new Promise((resolve, reject) => {
        let img = new Image();

        let mimeType = 'image/webp';

        img.onload = async (e) => {
            var canvas = document.createElement('canvas'),
                max_size = 1000,
                width = img.width,
                height = img.height;
            if (width > height) {
                if (width > max_size) {
                    height *= max_size / width;
                    width = max_size;
                }
            } else {
                if (height > max_size) {
                    width *= max_size / height;
                    height = max_size;
                }
            }
            canvas.width = width;
            canvas.height = height;
            canvas.getContext('2d').drawImage(img, 0, 0, width, height);

            URL.revokeObjectURL(img.src);

            function tryResolve(blob) {
                if (blob.type === mimeType)
                    return resolve(blob);

                return canvas.toBlob(resolve, "image/jpeg", 100);
            }

            canvas.toBlob(tryResolve, mimeType, 100);
        }

        if (v instanceof FileList) {
            const file = v[0];

            // mimeType = file.type;

            img.src = URL.createObjectURL(file);
        } else if (v instanceof File) {
            const file = v;

            // mimeType = file.type;

            img.src = URL.createObjectURL(file);
        } else {
            img.src = v;
        }
    });
}

export { downloadQCReport, checkQCExists, getDownloadDir, qcDirectoryName, readfile, resizeImgToBLOB }